import { apiFactory, getDefaultHeaders, getDefaultHeadersUpload } from './apiFactory';

const apiService = async (path, settings = {}) => {
  const { headers, body } = settings;
  const defaultHeaders = await getDefaultHeaders();
  const options = {
    ...settings,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    body: body instanceof FormData ? body : JSON.stringify(body),
  };
  return apiFactory(path, options);
};

const apiService2 = async (path, settings = {}) => {
  const { headers, body } = settings;
  const defaultHeaders = await getDefaultHeaders();
  const options = {
    ...settings,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    body: body instanceof FormData ? body : JSON.stringify(body),
  };
  return apiFactory(path, options);
};

const apiServiceUpload = async (path, settings = {}) => {
  const { headers, body } = settings;
  const defaultHeaders = await getDefaultHeadersUpload();
  const options = {
    ...settings,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    body: body instanceof FormData ? body : JSON.stringify(body),
  };
  return apiFactory(path, options);
};

export const apiPost = (path, body) => apiService(path, {
  method: 'post',
  body,
});

export const apiPostSemPost = (path) => apiService(path, {
  method: 'post',
});

// Caso dê algum problema, verificar o fire.uri,

export const upload = async (file) => {
  const body = new FormData();
  body.append('upload', file);

  const resp = await apiServiceUpload('/generico/enviararquivo', {
    method: 'post',
    plaintext: true,
    headers: {
      Accept: 'application/json',
    },
    body,
  });

  const remoteFileName = JSON.parse(resp).split(',')[0];

  // Possíveis erros: erro-upload-tamanho | erro-upload-tipo
  return remoteFileName.includes('erro') || !remoteFileName
    ? { ...file, error: remoteFileName }
    : { ...file, remoteFileName };
};

export default apiService;
